import {OxygenError} from '../types.js';

export const BuildCancelQuery = `
  mutation BuildCancel($buildId: ID!, $reason: String!) {
    buildCancel(id: $buildId, reason: $reason) {
      build {
        id
      }
      userErrors {
        message
      }
    }
  }
`;

export interface BuildCancelQueryData {
  buildCancel: BuildCancelResponse;
}

export interface BuildCancelResponse {
  build: {
    id: string;
  };
  userErrors: OxygenError[];
}
